<template>
    <v-container fluid>
        <v-data-table :headers="headers" :items="categories" :search="search" sort-by="calories" class="elevation-1">
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Categorias DGII</v-toolbar-title>

                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field class="mt-2" v-model="search" label="Buscar"></v-text-field>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialog" persistent width="50%" height="50%" hide-overlay
                        transition="dialog-bottom-transition">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="primary" outlined dark class="mb-2" v-bind="attrs" v-on="on">
                                <v-icon>add</v-icon>
                                Nuevo categoria DGII
                            </v-btn>
                        </template>
                        <v-card>
                            <v-card-title class="text-h5">
                                {{ formTitle }}
                            </v-card-title>
                            <v-card-text>
                                <v-container fluid>
                                    <v-row justify="center">
                                        <v-col cols="12" md="10">
                                            <v-row class="mt-5" no-gutters dense justify="center">
                                                <v-col cols="12" md="8">
                                                    <v-text-field v-model="editedItem.name" label="Nombre Categoria"
                                                        outlined />
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row justify="center" class="mt-2">
                                        <v-btn @click="
                                            (dialog = false),
                                            (editedItem.name = ''),
                                            (editedItem.id = null)
                                            " plain>Cancelar</v-btn>
                                        <v-btn @click="save" color="primary" outlined>Guardar</v-btn>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialogDelete" max-width="600px">
                        <v-card>
                            <v-card-title class="text-h5">Esta seguro que deseas eliminar esta categoria?</v-card-title>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="closeDelete">Cancelar</v-btn>
                                <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                <v-spacer></v-spacer>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small color="blue" class="mr-2" @click="editItem(item)">
                    mdi-pencil
                </v-icon>
                <v-icon small color="red" @click="deleteItem(item)">
                    mdi-delete
                </v-icon>
            </template>
        </v-data-table>
    </v-container>
</template>
<script>
import moment from "moment";
export default {
    name: "Categories",
    data() {
        return {
            dialogDelete: false,
            search: "",
            headers: [
                {
                    text: "Codigo",
                    align: "start",
                    sortable: false,
                    value: "id",
                },
                { text: "Nombre", value: "name" },

                { text: "Actions", value: "actions", sortable: false },
            ],
            categories: [],
            editedIndex: -1,
            editedItem: { id: null, name: "" },

            dialog: false,
        };
    },
    created() {
        this.init();
    },

    computed: {
        formTitle() {
            return this.editedIndex === -1
                ? "Nueva categoria DGII"
                : "Editar categoria DGII";
        },
    },

    methods: {
        async init() {
            const response = await this.api_Get("accounting/category_dgii");

            this.categories = await response.json();
        },
        async editItem(item) {
            this.editedItem = { id: null, name: "" };
            this.editedIndex = this.categories.indexOf(item);

            this.editedItem = Object.assign({}, item);

            this.dialog = true;
        },
        deleteItem(item) {
            this.editedIndex = this.categories.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialogDelete = true;
        },
        async deleteItemConfirm() {
            try {
                const request = await this.api_Delete(
                    "accounting/category_dgii/" + this.editedItem.id
                );
                if (request.status == 200) {
                    this.$toast.success("Categoria eliminado!");
                    this.init();
                }
            } catch (error) {
            }
            this.closeDelete();
        },
        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
                this.image_storage = null;
            });
        },

        closeDelete() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        async save() {
            if (this.editedItem.name == "") {
                this.$toast.info("Debes elegir un nombre");
                return;
            }

            try {
                let data = {
                    id: this.editedItem.id,
                    name: this.editedItem.name,
                };
                if (this.editedItem.id === null) {
                    const response = await this.api_Post(
                        "accounting/category_dgii",
                        data
                    );
                    if (response.status == 200) {
                        this.$toast.success("Categoria creado con exito");
                        this.init();
                    } else {
                        this.$toast.error("error ");
                    }
                } else {
                    const response = await this.api_Put("accounting/category_dgii", data);
                    if (response.status == 200) {
                        this.$toast.success("Categoria actualizada con exito");
                        this.init();
                    } else {
                        this.$toast.error("error ");
                    }
                }
            } catch (e) {
                this.$toast.error("error " + e.message);
            }

            this.close();
        },

        getDate(date) {
            let newDate = moment(date).format("YYYY-MM-DD HH:MM:SS A").toString();
            return newDate;
        },
    },
};
</script>
